import { render } from "./Modulos.vue?vue&type=template&id=02209696&scoped=true"
import script from "./Modulos.vue?vue&type=script&lang=js"
export * from "./Modulos.vue?vue&type=script&lang=js"

import "./Modulos.vue?vue&type=style&index=0&id=02209696&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02209696"]])

export default __exports__